/**
* Branch network aggregator — single source of truth.
*
* COMPLIANCE: only entries where `hasPostalAddress(b)` is true may be
* emitted with a schema.org PostalAddress / LocalBusiness node. All other
* entries are service areas (appointment / mobile visit only).
*/
import { BANGKOK_BRANCHES } from "./bangkok";
import { VICINITY_BRANCHES } from "./vicinity";
import { PROVINCE_BRANCHES } from "./provinces";
import { TRANSIT_BRANCHES } from "./transit";
import { MALL_BRANCHES } from "./malls";
import { OFFICE_LOCATIONS } from "./offices";
import { hasPostalAddress, type Branch } from "./types";

export * from "./types";
export { BANGKOK_BRANCHES, VICINITY_BRANCHES, PROVINCE_BRANCHES, TRANSIT_BRANCHES, MALL_BRANCHES, OFFICE_LOCATIONS };

export const ALL_BRANCHES: Branch[] = [
  ...BANGKOK_BRANCHES,
  ...OFFICE_LOCATIONS,
  ...VICINITY_BRANCHES,
  ...PROVINCE_BRANCHES,
  ...TRANSIT_BRANCHES,
  ...MALL_BRANCHES,
].filter((b, i, all) => all.findIndex((x) => x.id === b.id) === i);

/** Points with a real, staffed street address (safe for LocalBusiness). */
export const OFFICE_BRANCHES = ALL_BRANCHES.filter(hasPostalAddress);

/** Appointment-only service areas (emitted as areaServed, never an address). */
export const SERVICE_AREA_BRANCHES = ALL_BRANCHES.filter((b) => !hasPostalAddress(b));

export function branchById(id: string) {
  return ALL_BRANCHES.find((b) => b.id === id);
}

export function branchesInProvince(slug: string) {
  return ALL_BRANCHES.filter((b) => b.provinceSlug === slug);
}

export function branchesInDistrict(slug: string) {
  return ALL_BRANCHES.filter((b) => b.districtSlug === slug);
}
